import { render, staticRenderFns } from "./UploadFilesList.vue?vue&type=template&id=15820b15&"
import script from "./UploadFilesList.vue?vue&type=script&lang=js&"
export * from "./UploadFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports